<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
   
      <el-form-item label="是否开启一物一码" >
        <el-switch v-model="form.is_open"></el-switch>
      </el-form-item>

      <el-form-item label="查询间隔" prop="interval" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.interval" type="number" min=10 class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="每次更新数量" prop="num" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.num" type="number" min=10 max=100 class="max-w460"></el-input>
        <div>最大更新100条</div>
      </el-form-item>
      <!-- <el-form-item label="限制查询时间" prop="querytime" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.querytime" type="number" min=1 class="max-w460"></el-input>
        <div>最低每隔多少小时更新一次数据</div>
      </el-form-item> -->


    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import OiocApi from '@/api/oioc.js';
export default {
  data() {
    return {
      form: {
        is_open:false,
        querytime:20,
        interval:10,
        num:50
      },
      setting: [],
      loading: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      OiocApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;
       
        })
        .catch(error => {});
    },

    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      if(params.num > 100){
        self.$message({
              message: '最高更新数量不能大于100条哦',
              type: 'error'
            });
            self.loading = false;
            return;
      }
      OiocApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/oioc/setting/getSetting.vue